import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types';

const URL = '/v2/admin/refresh-checkr-report';

class AdminRefreshCheckrReportService {
  static post(data: unknown, config?: AxiosRequestConfig): Promise<DataResponse<unknown>> {
    return axios.post(URL, data, config);
  }
}

export { AdminRefreshCheckrReportService };
